import { BaseService } from "@/script/core/service/BaseService";

export class ProductService extends BaseService {
  public put(ids: number[]): Promise<any> {
    return super.post("/api/shop/product/put", ids);
  }

  public out(ids: number[]): Promise<any> {
    return super.post("/api/shop/product/out", ids);
  }
}
